import { Box } from '@factorialco/deprecated-design-system'
import { StandardLayout } from '@factorialco/f0-react'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

export const PageSkeleton = () => {
  return (
    <StandardLayout variant="narrow">
      <Box
        alignItems="center"
        justifyContent="center"
        position="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Spinner />
      </Box>
    </StandardLayout>
  )
}
